import { render, staticRenderFns } from "./afterSalesReasons.vue?vue&type=template&id=b73d48e8"
import script from "./afterSalesReasons.vue?vue&type=script&lang=js"
export * from "./afterSalesReasons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b73d48e8')) {
      api.createRecord('b73d48e8', component.options)
    } else {
      api.reload('b73d48e8', component.options)
    }
    module.hot.accept("./afterSalesReasons.vue?vue&type=template&id=b73d48e8", function () {
      api.rerender('b73d48e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/config/afterSalesReasons.vue"
export default component.exports